/* Gravur-MAX Konfigurator v3: Live-Vorschau (Produktfoto oder Textvorschau) */
(function(){
var GM=window.GM=window.GM||{};
/* Gravur-Position auf dem Foto, Anteile der Bildbreite (quadratisches Foto) */
var P2={cx:[.278,.724],t:{y:.243,w:.21,h:.065,fs:.046},m:{y:.300,w:.255},n:{y:.354,w:.21,h:.065,fs:.046}};
var P1={cx:[.5025],t:{y:.238,w:.205,h:.065,fs:.046},m:{y:.300,w:.255},n:{y:.358,w:.205,h:.065,fs:.046}};
function mg(a,b){var o={},k;for(k in a)o[k]=a[k];for(k in b)o[k]=(b[k]&&typeof b[k]==='object'&&!Array.isArray(b[k])&&a[k])?mg(a[k],b[k]):b[k];return o;}
/* Glasform aus den Template-Einstellungen (window.GM_GEO) */
var GEO=window.GM_GEO||{};
if(GEO.p2)P2=mg(P2,GEO.p2);
if(GEO.p1)P1=mg(P1,GEO.p1);
var P=P2;
function pct(v){return (v*100).toFixed(3)+'%';}
function val(r){return r?(r.input.value||'').trim():'';}
GM.val=val;

GM.views=function(n){
var v={all:GEO.all||{x:-.175,y:-.01,w:1.35}};
for(var i=0;i<P.cx.length;i++)v['g'+(i+1)]={x:P.cx[i]-.2,y:(GEO.zy!=null?GEO.zy:.085),w:.4};
return v;
};

/* Foto-Vorschau */
GM.buildPhoto=function(cfg,nums,motif){
P=nums.length>1?P2:P1;GM.P=P;
var el=document.createElement('div');
el.className='gm-photo';
var lay='<div class="gm-photo__layer"><img class="gm-photo__img" alt="" src="'+cfg.leer+'">'+(cfg.wein?'<img class="gm-photo__img gm-photo__img--wein" alt="" src="'+cfg.wein+'">':'');
nums.forEach(function(n,i){
if(i>=P.cx.length)return;
var cx=P.cx[i];
lay+='<span class="gm-pe gm-pe--t" data-g="'+n+'" data-r="t" style="left:'+pct(cx-P.t.w/2)+';width:'+pct(P.t.w)+';top:'+pct(P.t.y-P.t.h/2)+';height:'+pct(P.t.h)+'"><span class="gm-pe__x" data-fit="'+P.t.fs+'"></span></span>';
var hf=P.m.hf||.15;
if(motif)lay+='<span class="gm-pe gm-pe--m" style="left:'+pct(cx-P.m.w/2)+';width:'+pct(P.m.w)+';top:'+pct(P.m.y-P.m.w*hf/2)+';height:'+pct(P.m.w*hf)+'"><img alt="" src="'+motif+'"'+(P.m.ty!=null?' style="transform:translateY('+P.m.ty+'%)"':'')+'></span>';
lay+='<span class="gm-pe gm-pe--n" data-g="'+n+'" data-r="n" style="left:'+pct(cx-P.n.w/2)+';width:'+pct(P.n.w)+';top:'+pct(P.n.y-P.n.h/2)+';height:'+pct(P.n.h)+'"><span class="gm-pe__x" data-fit="'+P.n.fs+'"></span></span>';
});
lay+='</div>';
el.innerHTML=lay;
return el;
};
GM.setView=function(key){
if(!GM.photo)return;
var v=GM.viewMap[key]||GM.viewMap.all;
GM.view=key;
var L=GM.photo.querySelector('.gm-photo__layer');
L.style.transform='scale('+(1/v.w)+') translate('+(-v.x*100)+'%,'+(-v.y*100)+'%)';
if(GM.onView)GM.onView(key);
};

/* Textvorschau fuer Produkte ohne Fotovorlage */
GM.buildText=function(nums,motifName){
var el=document.createElement('div');
el.className='gm-tprev';
var h='';
nums.forEach(function(n){
h+='<div class="gm-tprev__g" data-g="'+n+'"><span class="gm-tprev__x" data-g="'+n+'" data-r="t"></span>'+(motifName?'<span class="gm-tprev__m">'+motifName+'</span>':'')+'<span class="gm-tprev__x" data-g="'+n+'" data-r="n"></span></div>';
});
el.innerHTML=h;
return el;
};

function fit(el,frac){
var box=el.parentNode,w=box.clientWidth,h=box.clientHeight;
if(!w||!el.textContent){el.style.fontSize='';return;}
var lw=GM.photo.querySelector('.gm-photo__layer').clientWidth;
var fs=frac*lw*(el.__k||1),g=0;
el.style.fontSize=fs+'px';
while((el.scrollWidth>w+.5||el.offsetHeight>h*1.25)&&fs>4&&g++<80){fs*=.94;el.style.fontSize=fs+'px';}
}
function paint(el,r,ph){
var v=val(r);
el.classList.remove('is-ph');
el.style.fontFamily='';
el.__k=1;
if(!r||v==='OHNE'){el.textContent='';return;}
var f=r.chosen||(r.font&&r.font.value);
if(f){el.style.setProperty('font-family','"'+f+'", cursive','important');el.__k=(GM.fsz&&GM.fsz[f])?GM.fsz[f]/45:1;}
if(!v){el.textContent=ph;el.classList.add('is-ph');return;}
if(el.textContent!==v)el.textContent=v;
}

GM.last='';
GM.render=function(force){
if(!GM.wrap)return;
var cards=GM.cards;
var sig=GM.rows.map(function(r){return r.input.value+'|'+(r.chosen||'');}).join('~')+'#'+GM.state.active+'#'+GM.wrap.clientWidth;
if(sig===GM.last&&!force)return;
GM.last=sig;
GM.wrap.querySelectorAll('[data-r]').forEach(function(slot){
var c=cards[+slot.getAttribute('data-g')];
if(!c)return;
var r=slot.getAttribute('data-r')==='t'?c.text:c.name;
var x=slot.querySelector('.gm-pe__x')||slot;
paint(x,r,slot.getAttribute('data-r')==='t'?'Für immer':'Anna & Tom');
if(x.getAttribute('data-fit')&&GM.photo)fit(x,+x.getAttribute('data-fit'));
});
GM.wrap.querySelectorAll('.gm-tprev__g').forEach(function(g){g.hidden=+g.getAttribute('data-g')!==GM.state.active;});
if(GM.afterRender)GM.afterRender();
};
})();